import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import useLoadReport from '../hooks/useLoadReport';
import NoDataDialog from './NoDataDialog';
import { reportReset, changeCoverageDay } from '../actions/index';
import MapCoverageReport from './MapCoverageReport';

const CoverageReportView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const data = React.useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    return {
      type: 'coverage',
      objectId: queryParams.get('object'),
      start: moment(queryParams.get('start')),
      end: moment(queryParams.get('end')),
    };
  }, [location.search]);

  // const hasMissingParams = !data.objectId || !data.start || !data.end;

  const loadReport = useLoadReport(data);

  React.useEffect(() => {
    loadReport.loadAsync.then(() => {
      // Report loaded successfully
    });
    return () => loadReport.controller.abort();
  }, [loadReport]);

  const onConfirm = () => {
    history.goBack();
    dispatch(reportReset('coverage'));
  };
  const coverageReport = useSelector(state => state.coverageReport);

  const handleSelectItem = React.useCallback(selectedDayData => {
    dispatch(changeCoverageDay(selectedDayData));
  }, [dispatch]);
  // const data = React.useMemo(() => {
  //   return {
  //     data: coverageReport.data,
  //     selectedDayData: coverageReport.selectedDayData,
  //   };
  // }, [coverageReport]);
  const errorDialog = coverageReport.status === 'nodata';

  return (
    <React.Fragment>
      {errorDialog && (
        <NoDataDialog
          open={true}
          onClose={onConfirm}
          objectName={coverageReport.queryParams.name}
          startDate={coverageReport.queryParams.start}
          endDate={coverageReport.queryParams.end}
        />
      )}
      <MapCoverageReport 
        data={coverageReport.data} 
        selectedDayData={coverageReport.selectedDayData} 
        params={coverageReport.queryParams}
        onSelectItem={handleSelectItem}
      />
    </React.Fragment>
  );
};

// ViewStack.propTypes = {
//   views: PropTypes.object,
//   show: PropTypes.string,
// };

export default CoverageReportView;
